import { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import { CaretDownIconSmall } from '../../../icon/icons-small/caret-down-small';
import { ActionPressedChip, ActionPressedChipProps } from './action-pressed-chip';

type ActionDropdownChip = Omit<ActionPressedChipProps, 'endIcon'> & {
  isOpen?: boolean;
  showCaret?: boolean;
};

const chevronStyle = css`
  transition: transform 300ms ease-out;
  display: flex;
  flex-direction: center;
  justify-content: center;
  transform: rotate(0deg);
`;

const chevronOpenStyle = css`
  transform: rotate(180deg);
`;

export const ActionDropdownChip = forwardRef<HTMLButtonElement, ActionDropdownChip>(
  ({ isOpen, showCaret = true, children, ...rest }, ref) => {
    return (
      <ActionPressedChip
        ref={ref}
        {...rest}
        endIcon={
          showCaret ? (
            <span className={cx('chevron-arrow', chevronStyle, isOpen && chevronOpenStyle)}>
              <CaretDownIconSmall size={8} />
            </span>
          ) : null
        }
      >
        {children}
      </ActionPressedChip>
    );
  }
);

ActionDropdownChip.displayName = 'ActionDropdownChip';
